import { useEffect, useState } from "react";
import { Activity, Users } from "lucide-react";
import { api } from "@/lib/api";

export default function StatusWidget() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const load = () => api.get("/server-status").then((r) => setStatus(r.data)).catch(() => setStatus({ online: false }));
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const online = status?.online;
  return (
    <div className="p-4 rounded-lg border border-white/5 bg-black/40" data-testid="server-status-widget">
      <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2 flex items-center gap-2">
        <Activity size={12} /> Status serwera
      </div>
      <div className="flex items-center justify-between">
        <span
          className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-semibold border ${
            status === null ? "border-slate-600 text-slate-400" : online ? "border-emerald-500/60 bg-emerald-950/60 text-emerald-300" : "border-red-500/60 bg-red-950/60 text-red-300"
          }`}
          data-testid="server-status-badge"
        >
          <span className={`w-2 h-2 rounded-full ${online ? "bg-emerald-400 animate-pulse" : status === null ? "bg-slate-500" : "bg-red-400"}`} />
          {status === null ? "Sprawdzanie..." : online ? "Online" : "Offline"}
        </span>
        {online && <span className="text-xs text-slate-400 font-mono" data-testid="server-ping">{status.ping} ms</span>}
      </div>
      {online && status.players != null && (
        <div className="mt-3 flex items-center gap-2 text-sm text-slate-300" data-testid="server-players">
          <Users size={14} className="text-amber-400" />
          <span className="font-mono text-amber-200 text-base" data-testid="server-players-count">{status.players}</span>
          <span className="text-xs text-slate-500">graczy online</span>
        </div>
      )}
    </div>
  );
}
